"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { toolCategories } from "@/lib/tools/registry";
import { cn } from "@/lib/utils";

export function ToolCategoryNav() {
  const pathname = usePathname();

  return (
    <nav className="space-y-1" aria-label="Tool categories">
      <Link
        href="/tools"
        prefetch={false}
        className={cn(
          "flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-zinc-600 hover:bg-zinc-100 hover:text-zinc-950",
          pathname === "/tools" && "bg-zinc-100 text-zinc-950",
        )}
      >
        All tools
      </Link>
      {toolCategories.map((category) => {
        const Icon = category.icon;
        const href = `/tools/categories/${category.id}`;
        const active = pathname === href;

        return (
          <Link
            key={category.id}
            href={href}
            prefetch={false}
            className={cn(
              "flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-zinc-600 hover:bg-zinc-100 hover:text-zinc-950",
              active && "bg-zinc-100 text-zinc-950",
            )}
          >
            <Icon className="h-4 w-4" />
            {category.name}
          </Link>
        );
      })}
    </nav>
  );
}
